import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const path = window.location.pathname;
if (path === '/privacy' || path === '/terms') {
  // Prevent React hydration to allow Vercel fallback static HTML to render
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
